// extracted by mini-css-extract-plugin
module.exports = {"container":"container-1caYy","warningMessage":"warningMessage-JhMvY","notifications":"notifications-ho3Hp","services":"services-jIsBZ"};